import {Hydra} from '../generic/hydra';

import {LocalisationScInterface} from './LocalisationSc';
import {LocalisationMetastaseInterface} from './LocalisationMetastase';
import {LocalisationInfoItem as LocalisationInfoItemBaseInterface} from '../../interface/api/LocalisationInfoItem';

export type LocalisationInfoItemInterface = LocalisationInfoItemBaseInterface;

export class LocalisationInfoItem extends Hydra implements LocalisationInfoItemInterface {

    id?: number | null;

    localisation?: LocalisationScInterface | string | null;

    precisionLocalisation?: string | null;

    localisationMetastases?: LocalisationMetastaseInterface[] | null = [];


    constructor(options: LocalisationInfoItemInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
